import ApiService from "@/utils/api.service";

export default {

    create(context, group) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("group", group)
                .then(({ data }) => {
                    resolve(data);
                }).catch(({ response }) => {
                    reject(response.data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
    delete(context, groupId) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.delete("group/" + groupId)
                .then(({ data }) => {
                    resolve(data);
                }).catch(({ response }) => {
                    reject(response.data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

    update(context, group) {
        return new Promise((resolve, reject) => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.put("group/" + group.id, group)
                .then(({ data }) => {
                    resolve(data);
                }).catch(({ response }) => {
                    reject(response.data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },

    detail(context, groupId) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });

            ApiService.get("group/" + groupId)
                .then(({ data }) => {
                    resolve(data);
                })

                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });
        });
    },
}